<script>
  import Badge from '../Badge.svelte';
  import { scaleOrdinal, scaleThreshold } from 'd3-scale';

  export let value;
  export let minValue = 0;
  export let maxValue;
  export let valueFormat = (v) => v;

  export let colorScale = scaleOrdinal()
    .domain([1, 2, 3, 4])
    .range(['#802f67', '#c43d53', '#d97641', '#e6b735']);

  export let thresholds;
  export let threshold = scaleThreshold()
    .domain(thresholds)
    .range([4, 3, 2, 1]);
  export let segmentFormat = (v) => `Tier ${v}`;
</script>

<Badge
  bind:value
  bind:minValue
  bind:maxValue
  bind:valueFormat
  bind:colorScale
  bind:threshold
  bind:segmentFormat
/>
